import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'

// store modules
import getters from './getters'
import ownerSetting from './modules/owner_setting'
import role from './modules/role'
import settings from './modules/settings'
import user from './modules/user'
import menu from './modules/menu'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    // store modules
    ownerSetting,
    role,
    settings,
    user,
    menu
  },
  getters
})

export default store
